<template>
    <div id="customer_show_core_waybill">
        <CoreWaybill
            v-if="is_initialized"
            :core_waybill="core_waybill"
            :template="'detail'"
            :scope="'customer'"
            :statuses="statuses"
            :is_auto_print="false"
            :is_can_update="current_customer.is_modification_allowed"
            :is_can_print_label="true"
            :is_show_change_template_btns="current_customer.is_modification_allowed"
            :detail="{
                is_show_blood_related: true,
                is_show_receipt_file: true,
                is_show_partition: true,
                is_show_statuses: true,
            }"
        >
        </CoreWaybill>
    </div>
</template>

<script>
import CoreWaybill from '@toolbox/core_waybill/main.vue'

export default {
    components: {
        CoreWaybill
    },
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            core_waybill: {},
            statuses: [],
            errors: [],
        }
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "customer_show_core_waybill") {
                this.init()
            }
        },
    },
    computed: {
        current_store() {
            return this.$store.state.customer.core_waybills_module
        },
        current_customer() {
            return this.$store.state.customer.customer
        }
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.is_processing = false
                this.core_waybill = {}
                this.statuses = []
                this.errors = []
                resolve()
            })
            await this.fetch_core_waybill()
            await this.fetch_statuses()
            await new Promise(resolve => {
                this.$store.state.customer.core_waybills_module.current_core_waybill = this.core_waybill
                this.is_initialized = true
            })
        },
        fetch_core_waybill() {
            var url = new RestUrl(this.$store.state.customer.routes.api_v1_customer_core_waybill).parse(
                {
                    "core_waybill_identity": this.$route.params.identity
                }
            )
            return axios.get(url, {headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
                .then(response => {
                    this.core_waybill = response.data.core_waybill
                })
                .catch(error => {
                    // this.$noty.error('取得運單資訊失敗')
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.core_waybills'),
                            reason: ': ' + error
                        })
                    )
                    return Promise.reject(error)
                })
        },
        fetch_statuses() {
            var rest_url = new RestUrl(this.$store.state.customer.routes.api_v1_customer_statuses)
            var url = rest_url.parse(
                {
                    core_waybill_identity: this.$route.params.identity,
                },""
            )

            return axios.get(
                url,
                {
                    headers: { Authorization: localStorage.getItem("customer_authentication_token") }
                }
            ).then(response => {
                if (response.data.status == "success") {
                    this.statuses = response.data.core_waybill_statuses
                } else {
                    return Promise.reject("查無 貨況資訊")
                }
            })
        },
    },
}
</script>
